export default __webpack_public_path__ + "static/index_reason_support-913e2b133e187df8c3631d22105812b3.png";